import notificationsTranslations from 'projects/main/src/app/pages/notification-center/i18n/pt-BR.json'
import assetsTree from '../../../../elements/assets-tree/i18n/pt-BR.json'
import createOrEditPendencyDialog from '../../../../elements/create-or-edit-pendency-dialog/i18n/pt-BR.json'
import fcMaintenanceSelect from '../../../../elements/fc-maintenance-select/i18n/pt-BR.json'
import fcSelectMultiplePage from '../../../../elements/fc-select-multiple-paged/i18n/pt-BR.json'
import fcSelectPage from '../../../../elements/fc-select-paged/i18n/pt-BR.json'
import maintenanceProductsTab from '../../../../elements/maintenance-products-tab/i18n/pt-BR.json'
import maintenanceServicesTab from '../../../../elements/maintenance-services-tab/i18n/pt-BR.json'
import notificationsDialog from '../../../../elements/notifications-dialog/i18n/pt-BR.json'
import updatePendencyAssigneeModal from '../../../../elements/update-pendency-assignee-modal/i18n/pt-BR.json'
import warrantiesEquipmentTab from '../../../../elements/warranties-equipment-tab/i18n/pt-BR.json'
import warrantiesMaintenanceTab from '../../../../elements/warranties-maintenance-tab/i18n/pt-BR.json'
import pipes from '../../../../pipes/i18n/pt-BR.json'
import confirmDialog from '../../../components/confirm-dialog/i18n/pt-BR.json'
import translateMaintenanceStatus from '../../../pipes/translate-maintenance-status/i18n/pt-BR.json'

export default {
  ...assetsTree,
  ...translateMaintenanceStatus,
  ...confirmDialog,
  ...createOrEditPendencyDialog,
  ...updatePendencyAssigneeModal,
  ...fcMaintenanceSelect,
  ...fcSelectMultiplePage,
  ...fcSelectPage,
  ...notificationsDialog,
  ...pipes,
  ...notificationsTranslations,
  ...maintenanceProductsTab,
  ...maintenanceServicesTab,
  ...warrantiesEquipmentTab,
  ...warrantiesMaintenanceTab
}
